export default "__VITE_ASSET__TUUXSax8__"